import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "../../../models/common";

import { IExportData } from "../../../models/AddOns/Accounting/ExportData";
import http from "../../../common/http-commons";

export const ExportDataService = {
	getExportData: async (
		clientId: string,
		navigateToLogout: (path: string) => void,
	): Promise<IExportData | IServerError | IResponse | null | any> => {
		if (!clientId) return null;
		try {
			const response: AxiosResponse<IExportData> = await http.get<IExportData>(
				`/v1/xero-export-data/${clientId}/`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createExportData: async (
		requestPayload: any,
	): Promise<IExportData | IServerError | IResponse | any> => {
		const screenTag = requestPayload.exportDataPageName;
		console.log("screenTag", screenTag);
		const PanelTag = requestPayload.exportDataCurrentPanelTag;
		console.log("PanelTag", PanelTag);
		try {
			const response: AxiosResponse<IExportData> = await http.post<IExportData>(
				// `/v1/xero/payroll?company_short_name=${requestPayload.clientId}`,
				// requestPayload,
				`/v1/${
					screenTag === "net_suite"
						? "net-suite"
						: screenTag === "zoho_books"
							? "zoho-books"
							: screenTag === "quick_books"
								? "quick-books"
								: screenTag === "kashoo"
									? "kashoo"
									: screenTag === "taxslips"
										? "taxslips"
										: screenTag
				}/${
					PanelTag === "simplepay_invoice"
						? "invoice"
						: PanelTag === "payday_advance"
							? "payday-advance"
							: PanelTag
				}`,
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delExportData: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/export-data/${delPayload.clientId}/`,
				// delPayload.exportDataId
			);

			if (response.status === 204) {
				return "Export Data has been deleted successfully";
			} else if (response.status === 200) {
				return "Export Data has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
